var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"comico-global-header02__switch-site o-large-screen-object"},[_c('div',{staticClass:"comico-global-header02__switch-site-inner"},[_c('router-link',{staticClass:"comico-global-header02__switch-site-btn",attrs:{"to":{
        path: _vm.isAuth ? '' : ("/login?redirect=" + _vm.currentRouter)
      }}},[_vm._v(" 作品投稿"),_c('i',{staticClass:"i-arrow-r"})])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }